export default function HomeStylesElPaso() {
  const homeStyles = [
    {
      name: 'Southwestern Contemporary',
      popularity: 'Most Popular',
      priceRange: '$350K-$800K+',
      image: 'https://public.readdy.ai/ai/img_res/05d53252d36275db89ad489da820b8e3.jpg',
      pros: ['Timeless regional aesthetic', 'Energy-efficient design', 'Indoor-outdoor living flow', 'High resale value', 'Suits desert climate'],
      cons: ['Stucco requires maintenance', 'Tile roofing costs more', 'May require larger lot'],
      description: 'Southwestern contemporary style dominates El Paso\'s custom home market, blending traditional elements with modern design. Features include stucco exteriors, tile roofs, arched openings, and expansive outdoor living spaces perfect for our climate.'
    },
    {
      name: 'Modern Minimalist',
      popularity: 'Growing Trend',
      priceRange: '$400K-$1M+',
      image: 'https://readdy.ai/api/search-image?query=Sleek%20modern%20minimalist%20custom%20home%20in%20El%20Paso%2C%20contemporary%20architecture%20with%20clean%20geometric%20lines%20and%20large%20windows%2C%20neutral%20color%20palette%20with%20metal%20and%20glass%20elements%2C%20minimalist%20desert%20landscaping%2C%20mountain%20views%2C%20professional%20architectural%20photography%20showing%20luxury%20modern%20home%20design%20and%20sophisticated%20aesthetic&width=600&height=400&seq=customhome-modern-041&orientation=landscape',
      pros: ['Cutting-edge design', 'Open floor plans', 'Energy-efficient features', 'Low maintenance materials', 'Maximizes natural light'],
      cons: ['Higher construction costs', 'May not suit all lots', 'Requires experienced builder'],
      description: 'Modern minimalist homes feature clean lines, open spaces, and innovative materials. Popular with younger buyers, these homes emphasize energy efficiency, smart technology, and seamless indoor-outdoor transitions suited to El Paso living.'
    },
    {
      name: 'Ranch Style',
      popularity: 'Classic Choice',
      priceRange: '$300K-$650K',
      image: 'https://readdy.ai/api/search-image?query=Spacious%20ranch%20style%20custom%20home%20in%20El%20Paso%20Texas%2C%20single-story%20design%20with%20wide%20front%20porch%20and%20horizontal%20layout%2C%20brick%20and%20stone%20exterior%20with%20pitched%20roof%2C%20mature%20desert%20landscaping%2C%20mountain%20backdrop%2C%20professional%20real%20estate%20photography%20showing%20classic%20ranch%20home%20architecture%20and%20welcoming%20design&width=600&height=400&seq=customhome-ranch-042&orientation=landscape',
      pros: ['Single-story convenience', 'Accessible design', 'Easy maintenance', 'Family-friendly layout', 'Cost-effective construction'],
      cons: ['Requires larger lot', 'Less privacy from street', 'Limited vertical space'],
      description: 'Ranch-style homes remain popular in El Paso for their practicality and accessibility. Single-story layouts work well for families and aging-in-place, with open floor plans and easy access to outdoor spaces. Ideal for larger suburban lots.'
    },
    {
      name: 'Two-Story Traditional',
      popularity: 'Very Common',
      priceRange: '$350K-$750K',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20two-story%20traditional%20custom%20home%20in%20El%20Paso%2C%20classic%20architecture%20with%20brick%20and%20stucco%20exterior%2C%20pitched%20roof%20with%20dormers%2C%20symmetrical%20design%20with%20covered%20entry%2C%20professional%20landscaping%2C%20mountain%20views%2C%20professional%20real%20estate%20photography%20showing%20quality%20traditional%20home%20construction%20and%20timeless%20design&width=600&height=400&seq=customhome-twostory-043&orientation=landscape',
      pros: ['Maximizes smaller lots', 'Separate living zones', 'More privacy', 'Cost-efficient per square foot', 'Traditional appeal'],
      cons: ['Stairs may limit accessibility', 'Higher cooling costs', 'More complex construction'],
      description: 'Two-story homes maximize lot efficiency while providing distinct living zones. Master suites on main or upper levels offer flexibility. Popular in newer developments where lot sizes are smaller. Quality construction ensures proper insulation and HVAC zoning for comfort.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Popular Custom Home Styles in El Paso
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Understanding popular architectural styles helps you envision your dream home. Each style offers unique advantages suited to different preferences, lots, and budgets in El Paso.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {homeStyles.map((style, index) => (
            <div key={index} className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-shadow">
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={style.image} 
                  alt={`${style.name} custom home in El Paso`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{style.name}</h3>
                    <div className="flex gap-4 text-sm">
                      <span className="text-teal-600 font-medium">{style.popularity}</span>
                      <span className="text-gray-600">Price: {style.priceRange}</span>
                    </div>
                  </div>
                </div>
                
                <p className="text-sm text-gray-700 mb-4 leading-relaxed">{style.description}</p>
                
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <i className="ri-check-line text-green-600"></i>
                      Advantages
                    </h4>
                    <ul className="space-y-1">
                      {style.pros.map((pro, i) => (
                        <li key={i} className="text-xs text-gray-600 flex items-start gap-2">
                          <span className="text-green-600 mt-0.5">•</span>
                          {pro}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-2">
                      <i className="ri-information-line text-orange-600"></i>
                      Considerations
                    </h4>
                    <ul className="space-y-1">
                      {style.cons.map((con, i) => (
                        <li key={i} className="text-xs text-gray-600 flex items-start gap-2">
                          <span className="text-orange-600 mt-0.5">•</span>
                          {con}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
